import {
  AlertTriangle,
  Bladder,
  Gallbladder,
  GeneralSurgery,
  HeartOrgan,
  IDocumentsAccepted,
  IDocumentsDenied,
  Kidneys,
  Liver,
  Lungs,
  Orthopaedics,
  Pregnant,
  Radiology,
  StarLarge,
  Stethoscope,
  UltrasoundScanner,
  VascularSurgery,
} from "healthicons-react/filled";
import type { FC, SVGProps } from "react";
import type { ExamType } from "../../../global-providers/rxdb-provider/collections/epocus-exam-worksheets";

export type HealthIconComponent = FC<SVGProps<SVGSVGElement>>;

// Exam type → healthicon component.
// Keys must stay in sync with the ExamType union.
export const EXAM_ICONS: Record<ExamType, HealthIconComponent> = {
  efast: UltrasoundScanner,
  cardiac: HeartOrgan,
  lung: Lungs,
  bladder: Bladder,
  renal: Kidneys,
  aorta: VascularSurgery,
  pregnancy: Pregnant,
};

// Pre-emptive mappings — add to EXAM_ICONS once ExamType is extended:
//   msk:         Orthopaedics   (specialties/orthopaedics)
//   gallbladder: Gallbladder    (body/gallbladder)
//   liver:       Liver          (body/liver)
//   general:     GeneralSurgery (specialties/general-surgery)
export const FUTURE_EXAM_ICONS = {
  msk: Orthopaedics,
  gallbladder: Gallbladder,
  liver: Liver,
  general: GeneralSurgery,
} as const;

// Stat card icons — ordered to match STAT_LABELS in home/page.tsx:
//   "TODAY'S SCANS" | "PENDING REVIEW" | "TOTAL ENCOUNTERS" | "AVG QA SCORE"
export const STAT_ICON_COMPONENTS = [
  UltrasoundScanner,
  Radiology,
  Stethoscope,
  StarLarge,
] as const;

// Misc UI icons re-exported for a consistent import path across the ePocus subtree.
export {
  AlertTriangle,
  IDocumentsAccepted,
  IDocumentsDenied,
  Stethoscope,
  UltrasoundScanner,
};
